import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';

import { restRequest } from '../../../Helpers/RequestHelper';
import { withFormik } from 'formik';

import { required, ValidateMax30 } from '../../../Helpers/Validator'; //ValidateMaxOnlyAlpha30,
import Field from '../Field/Field';
import Form from '../Form';
import FormAction from '../FormAction';
import ErrorFocus from '../ErrorFocus';
import { checkError } from '../../../Helpers/AuthHelper';
import { confirmationAlert } from '../../../Helpers';
import { isEqual } from 'lodash';
import { t } from 'i18next';

const formEnhancer = withFormik({
  validationSchema: Yup.object().shape({
    // name: required(ValidateMaxOnlyAlpha30),
    name: required(ValidateMax30),
  }),
  mapPropsToValues: ({ paymentMode }) => ({
    ...paymentMode,
  }),
  handleSubmit: (values, bag) => {
    handleFormSubmit(values, bag);
  },
});

const handleFormSubmit = (
  values,
  {
    setSubmitting,
    props: {
      requestType,
      requestUrl,
      inModal,
      onSubmitModal,
      history,
      successMessage,
      handleToast,
    },
  }
) => {
  const { name } = values;
  restRequest(requestType, requestUrl, {
    name,
  })
    .then((res) => {
      if (inModal) {
        onSubmitModal(res.data);
        if (history?.location?.pathname.includes('/paymentmethods')) {
          history.push('/paymentmethods');
        }
      } else {
        history.push('/paymentmethods');
      }
      successMessage();
    })
    .catch((error) => {
      checkError(error);
      handleToast(error, 'error');
      setSubmitting(false);
    });
};

const closeAndBack = (history, closeModal, totalRecords, modelSource) => {
  if (!modelSource) {
    closeModal();
  } else {
    closeModal();
    if (totalRecords === undefined || totalRecords === 0) {
      history.push('/settings');
    }
  }
};

const PaymentModeFormEnhancer = (props) => {
  const {
    values,
    handleSubmit,
    handleChange,
    handleBlur,
    // setFieldValue,
    isSubmitting,
    // submitCount,
    errors,
    touched,
    // custom props
    inModal,
    closeModal,
    history,
    title,
    paymentMode,
    totalRecords,
    modelSource = '',
    handleAlertmodal,
  } = props;

  const [staticVal, setStaticValues] = useState({});

  useEffect(() => {
    handleAlert();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values, staticVal]);

  useEffect(() => {
    setStaticValues(values);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const validateCreatepaymentForm = (data = {}, defaultValues = {}) => {
    let checkout = true;
    const checkEquality = Boolean(isEqual(data, defaultValues));
    const { name = '' } = data;
    if (name && !checkEquality) {
      checkout = false;
    }
    return { checkout };
  };

  useEffect(() => {
    const unloadCallback = (event) => {
      event.preventDefault();
      event.returnValue = '';
      return '';
    };

    window.addEventListener('beforeunload', unloadCallback);
    return () => window.removeEventListener('beforeunload', unloadCallback);
  }, []);

  const handleAlert = () => {
    let { checkout } = validateCreatepaymentForm(values, staticVal);
    handleAlertmodal(!checkout);
  };

  const handleCancel = () => {
    let response;
    let { checkout } = validateCreatepaymentForm(values, staticVal);
    if (!checkout) {
      response = confirmationAlert();
    }
    if (checkout || response) {
      if (inModal) closeAndBack(history, closeModal, totalRecords, modelSource);
      else history.push('/paymentmethods');
    }
  };

  return (
    <Form title={title} onSubmit={handleSubmit} className="paymentModes-form">
      <Field
        size="large"
        name={t('Settings.payment_method_name')}
        value={values.name}
        id="name"
        autoFocus={true}
        required
        handleChange={handleChange}
        error={touched.name && errors.name}
        onBlur={handleBlur}
      />
      <div style={{ marginTop: '1%' }} />
      <hr className="margin float-left w-100" />

      <FormAction
        disabled={paymentMode.name === values.name || isSubmitting}
        onCancel={handleCancel}
      />
      <ErrorFocus />
    </Form>
  );
};

export default formEnhancer(PaymentModeFormEnhancer);
